import { render, staticRenderFns } from "./appArticle.vue?vue&type=template&id=5eefebe2"
import script from "./appArticle.vue?vue&type=script&lang=js"
export * from "./appArticle.vue?vue&type=script&lang=js"
import style0 from "./appArticle.vue?vue&type=style&index=0&id=5eefebe2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports